import * as actionTypes from "../../../constants";

import type { CodeType, GridCodeType } from "../../../models";
import type { PresentOnAdmission } from "../../../models/codeGrid";

export enum InteractionType {
  Remove,
  MoveToPDx,
  SetAsAdmitDx,
  Add,
  InsertAsPDx,
  ReplacePDx,
  ViewInTabular,
  AddModifier,
  RemoveModifier,
  AddPOA,
}

export enum EditType {
  Article,
  Code,
  Unknown,
}

export enum PopupCaller {
  ResearchPane,
  PreventSaveDialog,
  Unknown,
}

export interface ResearchPaneCodeInteraction {
  code?: string;
  codeType?: CodeType | EditType;
  type: InteractionType;
  gridCodeType?: GridCodeType;
  referencedViewId?: string | null;
  poaValue?: PresentOnAdmission;
  modifierValue?: string;
  referencedToCodeModifier?: string;
}

export interface EditLocateEvent {
  viewId: string;
  gridCodeType: GridCodeType;
  field?: string;
}

export const editLocateEventAction = (e: EditLocateEvent) => (dispatch) => {
  dispatch({
    payload: e,
    type: actionTypes.RESEARCH_EDIT_LOCATE_EVENT,
  });
};

export const researchPaneCodeInteractionAction = (e: ResearchPaneCodeInteraction) => (dispatch) => {
  dispatch({
    payload: e,
    type: actionTypes.RESEARCH_PANE_INTERACTION,
  });
};

export const dismissEditAction = (id: string) => (dispatch) => {
  dispatch({
    payload: id,
    type: actionTypes.DISMISS_EDIT,
  });
};
